import { getLastRequestId } from '@multaqa/api-client'
import type { AppErrorMessages } from '@multaqa/ui/components/async/app-error'
import { AppErrorBoundary as SharedAppErrorBoundary } from '@multaqa/ui/components/async/app-error-boundary'
import type { ReactNode } from 'react'
import { reportBoundaryError } from '@/lib/sentry'

export function AppErrorBoundary({
  children,
  messages,
}: {
  children: ReactNode
  messages: AppErrorMessages
}) {
  return (
    <SharedAppErrorBoundary
      messages={messages}
      onError={(error, info) => {
        const requestId = getLastRequestId()
        reportBoundaryError(error, info, requestId ? { last_request_id: requestId } : {})
      }}
    >
      {children}
    </SharedAppErrorBoundary>
  )
}
